import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Hook para desativar o efeito de "overscroll" (ou "bounce")
 * em dispositivos móveis (Android) quando o app está rodando no Capacitor.
 * Isso previne o comportamento de "puxar para recarregar" da webview.
 */
export function useNoOverscroll(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const platform = Capacitor.getPlatform();
    const isNative = Capacitor.isNativePlatform();

    if (isNative && platform === 'android') {
      document.body.classList.add('no-overscroll-global', 'android', 'capacitor-app');
    } else {
      document.body.classList.add('no-overscroll-global');
    }

    return () => {
      document.body.classList.remove('no-overscroll-global', 'android', 'capacitor-app');
    };
  }, [enabled]);
}

/**
 * Hook para aplicar correções de overscroll globalmente no documento
 */
export const useGlobalNoOverscroll = () => {
  useEffect(() => {
    // Aplicar no documento
    const applyGlobalStyles = () => {
      document.documentElement.style.setProperty('overscroll-behavior', 'none', 'important');
      document.body.style.setProperty('overscroll-behavior', 'none', 'important');
      
      // Adicionar classe ao body para identificação
      document.body.classList.add('no-overscroll-global');
    };

    applyGlobalStyles();

    // Detectar plataforma e aplicar correções específicas
    const platform = (window as any).Capacitor?.getPlatform?.();
    
    if (platform === 'ios') {
      document.body.classList.add('ios');
    } else if (platform === 'android') {
      document.body.classList.add('android');
    }
    
    // Adicionar classe para Capacitor
    if ((window as any).Capacitor) {
      document.body.classList.add('capacitor-app');
    }

    return () => {
      // Cleanup opcional - remover classes se necessário
      document.body.classList.remove('no-overscroll-global', 'ios', 'android', 'capacitor-app');
    };
  }, []);
}; 